import { BrowserRouter, Route, Routes } from "react-router-dom";
import Dashbord from "./components/Dashbord";
import Login from "./components/Login";
// import Custmerform from "./components/Custmerform"
import Billhistorys from "./components/Billhistory";
import Changepass from "./components/Changepass/changepass";
import Customer from "./components/Customer";
import Customerbilling from "./components/Customerbilling";
import Layout from "./components/Layout";
import ForgotPassword from "./components/Login/ForgotPassword";
import OrderTable from "./components/OrderTable";
import Profilepage from "./components/Profilepage/profilepage";
import TotalOutstanding from "./components/TotalOutstanding";
import Totalorderpay from "./components/Totalorderpay/index";
import View from "./components/View";
import RequireAuth from "./components/requireAuth";
import "./scss/style.scss";
// import Itempage from './components/Itempage';
import ActionOutstanding from "./components/Customerbilling/ActionOutstanding";
import ItemsNotPicked from "./components/ItemsNotPicked/ItemsNotPicked";
import PrintBill from "./components/OrderTable/PrintBill";
import OutstandingViewList from "./components/OutstandingViewList/index";
import QrCode from "./components/QrCode";
import ReceivedList from "./components/ReceivedList/ReceivedList";
import Weeklyorders from "./components/WeeklyOrders/Weeklyorders";
import Yesterdaysorders from "./components/Yesterday's Order/Yesterdaysorders";

function App() {
  return (
    <div>
      <BrowserRouter basename={"/"}>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          {/* <Route path="/recover-password/:token?" element={<RecoverPassword />} /> */}
          <Route
            path="/dashboard"
            element={
              <RequireAuth>
                <Layout>
                  <Dashbord />
                </Layout>
              </RequireAuth>
            }
          />
          <Route
            path="/customer"
            element={
              <RequireAuth>
                <Layout>
                  <Customer />
                </Layout>
              </RequireAuth>
            }
          />
          <Route
            path="/order"
            element={
              <RequireAuth>
                <Layout>
                  <OrderTable />
                </Layout>
              </RequireAuth>
            }
          />
          <Route
            path="/order/print/:Id"
            element={
              <RequireAuth>
                <PrintBill />
              </RequireAuth>
            }
          />
          <Route
            path="/order/:Id"
            element={
              <RequireAuth>
                <Layout>
                  <OrderTable />
                </Layout>
              </RequireAuth>
            }
          />
          <Route
            path="/customerbilling"
            element={
              <RequireAuth>
                <Layout>
                  <Customerbilling />
                </Layout>
              </RequireAuth>
            }
          />
          <Route path="/customerbilling/actionoutstanding" element={<RequireAuth><Layout><ActionOutstanding /></Layout></RequireAuth>} />
          <Route
            path="/actionoutstanding"
            element={
              <RequireAuth>
                <Layout>
                  <ActionOutstanding />
                </Layout>
              </RequireAuth>
            }
          />
          <Route
            path="/view/:Id"
            element={
              <RequireAuth>
                <Layout>
                  <View />
                </Layout>
              </RequireAuth>
            }
          />
          <Route
            path="/totaloutstanding"
            element={
              <RequireAuth>
                <Layout>
                  <TotalOutstanding />
                </Layout>
              </RequireAuth>
            }
          />
          <Route
            path="/totaloutstanding/:customerIdd"
            element={
              <RequireAuth>
                <Layout>
                  <TotalOutstanding />
                </Layout>
              </RequireAuth>
            }
          />
          <Route
            path="/outstandingViewList/:customerIdd"
            element={
              <RequireAuth>
                <Layout>
                  <OutstandingViewList />
                </Layout>
              </RequireAuth>
            }
          />
          <Route
            path="/billhistory"
            element={
              <RequireAuth>
                <Layout>
                  <Billhistorys />
                </Layout>
              </RequireAuth>
            }
          />
          <Route
            path="/profilepage"
            element={
              <RequireAuth>
                <Layout>
                  <Profilepage />
                </Layout>
              </RequireAuth>
            }
          />
          <Route
            path="/changepass"
            element={
              <RequireAuth>
                <Layout>
                  <Changepass />
                </Layout>
              </RequireAuth>
            }
          />
          <Route
            path="/totalorderpay"
            element={
              <RequireAuth>
                <Layout>
                  <Totalorderpay />
                </Layout>
              </RequireAuth>
            }
          />
          <Route
            path="/lastweekorders"
            element={
              <RequireAuth>
                <Layout>
                  <Weeklyorders />
                </Layout>
              </RequireAuth>
            }
          />
          <Route
            path="/yesterdaysorders"
            element={
              <RequireAuth>
                <Layout>
                  <Yesterdaysorders />
                </Layout>
              </RequireAuth>
            }
          />
          <Route
            path="/itemnotpicked"
            element={
              <RequireAuth>
                <Layout>
                  <ItemsNotPicked />
                </Layout>
              </RequireAuth>
            }
          />
          <Route
            path="/receivedlist"
            element={
              <RequireAuth>
                <Layout>
                  <ReceivedList />
                </Layout>
              </RequireAuth>
            }
          />
          {/* <Route path="/itempage" element={<RequireAuth><Layout><Itempage /></Layout></RequireAuth>} /> */}
          <Route
            path="/qrscan"
            element={
              <RequireAuth>
                <Layout>
                  <QrCode />
                </Layout>
              </RequireAuth>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
